import { ContextKey } from '@pubstack/common/src/contextKey'
import { compareNames } from '@pubstack/common/src/sort'

/** How a context key's values are listed: the default value first, then the others by name. */
export const byDefaultThenName =
  (defaultValue: ContextKey['defaultValue']) =>
  (a: string, b: string): number =>
    Number(b === defaultValue) - Number(a === defaultValue) || compareNames(a, b)

/** A sorted copy of a context key's values; the key itself is left as it is. */
export const sortContextKeyValues = ({ values, defaultValue }: Pick<ContextKey, 'values' | 'defaultValue'>): string[] => [...values].sort(byDefaultThenName(defaultValue))
